import * as React from 'react';

function SvgCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M8.56 24a2.39 2.39 0 01-1.91-.95L.49 15A2.38 2.38 0 011 11.61a2.41 2.41 0 013.37.46l4 5.33L18.56 1.12a2.42 2.42 0 013.31-.76 2.39 2.39 0 01.77 3.29l-12 19.22A2.42 2.42 0 018.67 24z" />
    </svg>
  );
}

const MemoSvgCheck = React.memo(SvgCheck);
export default MemoSvgCheck;
